Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthContext = void 0;
var _react = require("react");
var AuthContext = exports.AuthContext = (0, _react.createContext)({
  isAuthenticated: false
});